import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DeliveryType } from 'app/models/user-order.model';

@Directive({
  selector: '[appTouchOutside]'
})
export class TouchOutsideDirective {
  @Input() deliveryTypeModal: DeliveryType;
  @Output() touchOutside = new EventEmitter<HTMLElement>();

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('document:mousedown', ['$event.target'])
  public onClick(targetElement: any): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.touchOutside.emit(this.elementRef.nativeElement);
    }
  }

  @HostListener('document:touchstart', ['$event.target'])
  public onTouchstart(targetElement: any): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.touchOutside.emit(this.elementRef.nativeElement);
    }
  }
}
